// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage } from "react-intl";

export const TrendingTagsTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lensTags.components.trendingTagsTitle"
        description="Trending tags title."
        defaultMessage="Tags of the Month"
    />
);
TrendingTagsTitle.displayName = "TrendingTagsTitle";

export const TrendingTagsTooltip = (props: { feature: ReactNode; link: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensTags.components.trendingTagsTooltip"
        description="Trending tags tooltip."
        defaultMessage="Add tags to your lenses that feature these events and / or holidays. To learn more about {feature} and how to use them, please see {link}."
        values={props}
    />
);
TrendingTagsTooltip.displayName = "TrendingTagsTooltip";
